var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative"
  }, [_c('img', {
    staticClass: "flexs h-840 w-001",
    attrs: {
      "src": require("../../assets/images/top.png")
    }
  }), _c('a', {
    staticClass: "animate__animated animate__fadeInRight custom-delay flexs jc-c al-c absolute b-330 l-150 fs-18 c-f back-2E6AFA w-200 h-60 radius-10",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "https://ad.jumao.net.cn/dist/"
    }
  }, [_vm._v("立即体验")]), _c('div', {
    staticClass: "flexs jc-sa al-c w-001 h-136 back-f absolute b-0 l-0 o-8"
  }, _vm._l(_vm.topData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "animate__animated animate__zoomIn flexs column"
    }, [_c('span', {
      staticClass: "fs-40 c-3"
    }, [_vm._v(_vm._s(item.num))]), _c('span', {
      staticClass: "fs-18 c-6"
    }, [_vm._v(_vm._s(item.label))])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };